import * as yup from 'yup';
import { yupDateRangeValidation } from '@product-framework/components/FormFields';

const validationSchema = formatMessage =>
  yup
    .object()
    .shape({
      invoiceNumber: yup.string().nullable(),
      invoiceDate: yupDateRangeValidation({
        testName: 'invoiceDate-value=required-on-operator',
        sameErrMessage: 'Invoice dates cannot be same for between',
        greaterThnErrMessage:
          'Invoice date start needs to be greater than end date',
        validBetweenDateMessage:
          'Invoice date must have 2 valid dates for between',
        requiredMessage: 'Invoice date is required',
        validDateMessage: 'Invoice date should be valid date',
      }),
      billingCycleStartDate: yupDateRangeValidation({
        testName: 'billingCycleStartDate-value=required-on-operator',
        sameErrMessage: 'Billing cycle start dates cannot be same for between',
        greaterThnErrMessage:
          'Billing cycle start date start needs to be greater than end date',
        validBetweenDateMessage:
          'Billing cycle start date must have 2 valid dates for between',
        requiredMessage: 'Billing cycle start date is required',
        validDateMessage: 'Billing cycle start date should be valid date',
      }),
      billingCycleEndDate: yupDateRangeValidation({
        testName: 'billingCycleEndDate-value=required-on-operator',
        sameErrMessage: 'Billing cycle end dates cannot be same for between',
        greaterThnErrMessage:
          'Billing cycle end date start needs to be greater than end date',
        validBetweenDateMessage:
          'Billing cycle end date must have 2 valid dates for between',
        requiredMessage: 'Billing cycle end date is required',
        validDateMessage: 'Billing cycle end date should be valid date',
      }),
    })
    .test(
      'at-least-one-required',
      formatMessage({
        id: 'AT_LEAST_ONE_FIELD_IS_REQUIRED',
        defaultMessage: 'At least one field is required',
      }),
      value => {
        return value &&
          typeof value === 'object' &&
          Object.values(value).length > 0 &&
          !Array.isArray(value)
          ? Object.values(value).some(val => val && val !== '')
          : false;
      },
    );

export default validationSchema;
